export type ModelProviderSource = 'pyrecast' | 'wifire';

export type ModelProviderMetadata = {
  source: ModelProviderSource;
  displayName: string;
  logoWordmark: string;
  logoIcon: string;
  learnMoreUrl: string;
};

export const MODEL_PROVIDERS: Record<
  ModelProviderSource,
  ModelProviderMetadata
> = {
  pyrecast: {
    source: 'pyrecast',
    displayName: 'PyreCast',
    logoWordmark: '/images/providers/pyrecast-wordmark.png',
    logoIcon: '/images/providers/pyrecast-icon.png',
    learnMoreUrl: 'https://pyrecast.org',
  },
  wifire: {
    source: 'wifire',
    displayName: 'WIFIRE',
    logoWordmark: '/images/providers/wifire-wordmark.png',
    logoIcon: '/images/providers/wifire-icon.png',
    learnMoreUrl: 'https://firemap.sdsc.edu/',
  },
};

export const getModelProvider = (
  source: string,
): ModelProviderMetadata | undefined =>
  MODEL_PROVIDERS[source as ModelProviderSource];
